<template>
<div class="example">
    <apexcharts
      width="100%"
      height="350"
      type="line"
      :options="chartOptions"
      :series="seriesData"
    ></apexcharts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
// import locales from '../../langs/apexChart/index.json'

export default {
  name: 'Chart',
  components: {
    apexcharts: VueApexCharts
  },
  data: function() {
    return {
      chartOptions: {
        chart: {
          id: 'basic-bar',
          animations: {
            speed: 200
          }
        },
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          bar: {
            distributed: true
          }
        },
        xaxis: {
          categories: [1991, 1992]
        }
      },
      series: [
        {
          name: 'series-1',
          data: [30, 40]
        }
      ]
    }
  },
  computed: {
    seriesData() {
      return [
        {
          type: 'column',
          name: this.$t('vuetifyWidgets.it-chart.level'),
          data: [10,20]
        },
        {
          type: 'line',
          name: this.$t('vuetifyWidgets.it-chart.median'),
          data: [5,8]
        }
      ]
    }
  },
  methods: {
    updateTheme(e) {
      this.chartOptions = {
        theme: {
          palette: e.target.value
        }
      }
    }
  }
}
</script>

<style>
</style>